export const theme = {
  descriptionColor: Styles.color.grey.one,
  disclaimerTextCssColor: Styles.color.grey.one,
  emptyStateBodyColor: Styles.color.grey.one,
  headingTextTransform: Styles.textTransform.headlines,
  pCssColor: Styles.color.grey.one,
  textColor: Styles.color.grey.one,
};
